import Line from '../../DataTable/Mobile/Line';
import '../../../styles/mobile-dt-summary.scss';
import { FormattedMessage } from 'react-intl';

const MobileSummaryModalContent = (props) => {
  return (
    <>
      <div className='mobile-summary-header'>
        <span>
          <FormattedMessage id='Data' />
        </span>
        <span>
          <FormattedMessage id='Titles' />
        </span>
      </div>
      {props.currencies.map((currency) => (
        <div className='summary-mobile' key={currency}>
          <div className='title-header'>
            <span className='currency-name'>
              <FormattedMessage id='Summary for' /> {currency}
            </span>
          </div>
          <Line
            label={<FormattedMessage id='Sum gross' />}
            value={`${props.displayValueForCurrency(props.grossValueSummary, currency)} ${currency}`}
            isExpanded
          />
        </div>
      ))}
    </>
  );
};

export default MobileSummaryModalContent;
